import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewStoryComponent } from './new-story.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { EditorModule } from '../../components/editor/editor.module';
import { MatButtonModule } from '@angular/material/button';
import { PublishDialogModule } from './publish-dialog/publish-dialog.module';
import { MatIconModule } from '@angular/material/icon';

const ANGULAR_MATERIAL_MODULES = [MatButtonModule, MatIconModule];

const CORE_MODULES = [CommonModule];

const COMPONENTS = [NewStoryComponent];

export const newStory_nav_path = {};

const routes: Routes = [
  { path: '', component: NewStoryComponent, pathMatch: 'full' }
];

@NgModule({
  declarations: [...COMPONENTS],
    imports: [
        RouterModule.forChild(routes), ...CORE_MODULES, PublishDialogModule,
        ...ANGULAR_MATERIAL_MODULES, SharedModule, EditorModule
    ],
  exports: [RouterModule],
  providers: []
})
export class NewStoryModule { }
